/**
 * The user-facing `detail` of a 4xx API error body
 * ({ code, field, detail }), or "" when there is none to show.
 *
 * 5xx and network failures (no response) never expose a detail, so callers
 * fall back to their generic message.
 */
export function getApiErrorDetail(error) {
  const response = error?.response;
  if (!response || !(response.status < 500)) return "";
  const detail = response.data?.detail;
  return typeof detail === "string" ? detail.trim() : "";
}
